import { ADD_WIDGET, REMOVE_WIDGET, SET_DOCK_ENABLED, SET_WIDGET_HIDDEN, SET_WIDGETS_ORDER, SET_COUNTERS_ENABLED } from '../constants'

const loadDockEnabled = () => {
  try {
    // default ON when nothing stored yet
    return localStorage.getItem('widgets_dock_enabled') !== '0'
  } catch (e) {
    return true
  }
}

const loadHiddenWidgets = () => {
  try {
    return JSON.parse(localStorage.getItem('widgets_hidden') || '[]') || []
  } catch (e) {
    return []
  }
}

const loadCountersEnabled = () => {
  try {
    // default ON when nothing stored yet
    return localStorage.getItem('counters_enabled') !== '0'
  } catch (e) {
    return true
  }
}

const loadWidgetsOrder = () => {
  try {
    return JSON.parse(localStorage.getItem('widgets_order') || '[]') || []
  } catch (e) {
    return []
  }
}

const persistHiddenWidgets = (list) => {
  try {
    localStorage.setItem('widgets_hidden', JSON.stringify(list))
  } catch (e) {
    /* storage disabled — ignore */
  }
}

const widgetsReducer = (state, action) => {

  const defaultState = {
    activeWidgets: [],
    dockEnabled: loadDockEnabled(),
    hiddenWidgets: loadHiddenWidgets(),
    widgetsOrder: loadWidgetsOrder(),
    countersEnabled: loadCountersEnabled()
  }

  if(!state){
    state = defaultState
  }

  const newActiveWidgets = state.activeWidgets.slice(0)

  switch(action.type){
    case ADD_WIDGET:
      if(newActiveWidgets.indexOf(action.data) === -1){
        newActiveWidgets.push(action.data)
      }
      return {
        ...state,
        activeWidgets: newActiveWidgets
      }
    case REMOVE_WIDGET:
      let index = newActiveWidgets.indexOf(action.data);
      if (index !== -1) {
        newActiveWidgets.splice(index, 1);
      }
      return  {
        ...state,
        activeWidgets: newActiveWidgets
      }
    case SET_DOCK_ENABLED:
      return {
        ...state,
        dockEnabled: action.data
      }
    case SET_WIDGET_HIDDEN: {
      const current = state.hiddenWidgets || []
      let hidden = current.filter((k) => k !== action.key)
      if (action.hidden) {
        hidden.push(action.key)
      }
      persistHiddenWidgets(hidden)
      return {
        ...state,
        hiddenWidgets: hidden
      }
    }
    case SET_WIDGETS_ORDER: {
      try {
        localStorage.setItem('widgets_order', JSON.stringify(action.data))
      } catch (e) {
        /* storage disabled — ignore */
      }
      return {
        ...state,
        widgetsOrder: action.data
      }
    }
    case SET_COUNTERS_ENABLED: {
      try {
        localStorage.setItem('counters_enabled', action.data ? '1' : '0')
      } catch (e) {
        /* storage disabled — ignore */
      }
      return {
        ...state,
        countersEnabled: action.data
      }
    }
    default:
      return state
  }
}

export default widgetsReducer
